import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconSettingsSvg } from "./IconSettingsSvg.mjs";
const IconSettings = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconSettingsSvg, ...svgProps }) });
export {
  IconSettings
};
